<template>
  <div class="app-modal" @click="$emit('close')">
    <div class="survey-content modal-content" @click="$event.stopPropagation()">
      <div class="header">
        <img class="arrow-left" src="@/assets/icons/arrow-white-alt.svg" @click="$emit('close')" />
        <span class="title" v-if="event.type === 'Lecture'">Ocijeni predavanje</span>
        <span class="title" v-if="event.type === 'Workshop'">Ocijeni radionicu</span>
        <img class="close" src="@/assets/icons/close.svg" @click="$emit('close')" />
      </div>

      <h1 class="survey-title">{{ event.name }}</h1>
      <section v-if="setOfQuestions === 1" class="survey-questions">
        <article v-for="(question, index) in surveyQuestions" v-bind:key="question.id">
          <h2>{{ question.question }}</h2>
          <div class="stars" v-if="question.questionType === 'Rating'">
            <span v-bind:class="{ 'star-filled': surveyData[index] > 0 }" @click="setSurveyData(index, 1)" />
            <span v-bind:class="{ 'star-filled': surveyData[index] > 1 }" @click="setSurveyData(index, 2)" />
            <span v-bind:class="{ 'star-filled': surveyData[index] > 2 }" @click="setSurveyData(index, 3)" />
            <span v-bind:class="{ 'star-filled': surveyData[index] > 3 }" @click="setSurveyData(index, 4)" />
            <span v-bind:class="{ 'star-filled': surveyData[index] > 4 }" @click="setSurveyData(index, 5)" />
          </div>
          <div class="form-field" v-if="question.questionType === 'Textarea'">
            <textarea v-model="surveyData[index]" />
          </div>
          <div class="form-field" v-if="question.questionType === 'Input'">
            <input v-model="surveyData[index]" />
          </div>
        </article>
        <div class="button-wrapper">
          <button class="button" v-on:click="next">Nastavi</button>
          <button class="button button-secondary" v-on:click="$emit('close')">Odustani</button>
        </div>
      </section>

      <section v-if="setOfQuestions === 2" class="survey-questions">
        <article>
          <h2>Opća ocjena</h2>
          <div class="stars">
            <span
              v-bind:class="{ 'star-filled': surveyData[surveyQuestions.length] > 0 }"
              @click="setSurveyData(surveyQuestions.length, 1)"
            />
            <span
              v-bind:class="{ 'star-filled': surveyData[surveyQuestions.length] > 1 }"
              @click="setSurveyData(surveyQuestions.length, 2)"
            />
            <span
              v-bind:class="{ 'star-filled': surveyData[surveyQuestions.length] > 2 }"
              @click="setSurveyData(surveyQuestions.length, 3)"
            />
            <span
              v-bind:class="{ 'star-filled': surveyData[surveyQuestions.length] > 3 }"
              @click="setSurveyData(surveyQuestions.length, 4)"
            />
            <span
              v-bind:class="{ 'star-filled': surveyData[surveyQuestions.length] > 4 }"
              @click="setSurveyData(surveyQuestions.length, 5)"
            />
          </div>
        </article>
        <article>
          <h2>Opći dojam</h2>
          <p>Napiši komentar o predavanju.</p>

          <div class="form-field">
            <textarea v-model="surveyData[surveyQuestions.length + 1]" />
          </div>
        </article>
        <div class="button-wrapper">
          <button class="button" v-on:click="$emit('submitSurvey')">Pošalji</button>
          <button class="button button-secondary" v-on:click="previous">Natrag</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyModal',
  props: {
    event: {},
    surveyData: Array,
  },
  data() {
    return {
      setOfQuestions: 1,
      surveyQuestions: [],
    };
  },
  methods: {
    next() {
      this.setOfQuestions += 1;
    },
    previous() {
      this.setOfQuestions -= 1;
    },
    setSurveyData(index, amount) {
      this.$set(this.surveyData, index, amount);
    },
  },
  created() {
    this.$axios
      .get(`${this.$API_URL}/survey-questions/all-survey-questions-for-event-type`, {
        params: { isForWorkshop: this.event.type === 'Workshop' },
      })
      .then(response => {
        this.surveyQuestions = response.data;
        for (let i = 0; i < this.surveyQuestions.length + 2; i++) {
          if (
            (this.surveyQuestions[i] && this.surveyQuestions[i].questionType === 'Rating') ||
            i === this.surveyQuestions.length
          ) {
            this.$set(this.surveyData, i, 0);
          } else {
            this.$set(this.surveyData, i, '');
          }
        }
      })
      .catch();
  },
  destroyed() {
    this.$set(this.surveyData, []);
  },
};
</script>

<style scoped>
h2,
p {
  margin: 0;
}

.app-modal {
  align-items: flex-start !important;
}

.survey-content {
  margin-top: 90px;
  margin-bottom: 40px;
  width: 33%;
  padding: 40px !important;
}

::-webkit-scrollbar {
  display: none;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 34px;
  align-items: center;
}

.title {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  margin-bottom: 0;
}

.close {
  cursor: pointer;
}

.arrow-left {
  display: none;
}

.survey-title {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  border-bottom: 1px solid #ffffff1a;
  padding-bottom: 20px;
  margin-bottom: 0 0 24px 0;
}

.survey-questions article {
  margin-bottom: 51px;
}

.survey-questions h2 {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
}

.survey-questions p {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #ffffffcc;
}

.stars {
  margin-top: 24px;
}

.stars > span {
  margin-right: 17px;
  display: inline-block;
  width: 38.4px;
  height: 36.8px;
  background-image: url('../../assets/app-icons/prizes/star.svg');
}

.star-filled {
  background-image: url('../../assets/app-icons/prizes/starfilled.svg') !important;
  background-size: 100%;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
}

.button {
  padding: 16px 0;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
  height: auto;
}

.button-secondary {
  margin-bottom: 0;
  border: 1px solid #ffffff;
  color: #ffffff;
  background-color: transparent;
}

.survey-questions textarea {
  resize: none;
  width: 100%;
  height: 160px;
  padding: 5px;
  border-radius: 8px;
  border-color: #ffffffcc;
  background-color: transparent;
  color: #ffffffcc;
  box-sizing: border-box;
  outline: none;
  margin-top: 24px;
}

.survey-questions input {
  border: none;
  border-bottom: 1.5px solid #7a8e94;
  font-size: 16px;
  padding: 25px 25px 10px 0;
  color: white;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  width: 100%;
  outline: none;
  background: transparent;
  transition: border-bottom 0.2s ease-in-out;
  box-sizing: border-box;
}

@media screen and (max-width: 1024px) {
  .content {
    width: 100%;
    height: 100%;
    border-radius: 0;
    padding-top: 53px;
  }

  .header {
    justify-content: flex-start;
  }

  .arrow-left {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin-right: 28px;
  }

  .close {
    display: none;
  }
}
</style>
